import Autocomplete from '@mui/material/Autocomplete';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import DatePicker from "react-datepicker";
import configJSON from '../../../Config.json';
import { DateTime } from "luxon";


const renderStageRequiredField = (currentSubmitData, candidateRequisitionStatus, requisitionDetailData, updateSubmitDataState, eventStatusFromEdit = null, onMandatoryFieldsValidation = null) => {


    let currentStatus = candidateRequisitionStatus.find((item) => item.candidateStatusCode === (eventStatusFromEdit ? eventStatusFromEdit?.candidateStatusCode : currentSubmitData?.status?.candidateStatusCode)) || {};

    let requiredFields = currentStatus?.fields || [];
    if (requisitionDetailData?.placementType === "Contract") {

        requiredFields = requiredFields.filter(field => field.altName !== 'salary');
    }
    else {
        requiredFields = requiredFields.filter(field => field.altName !== 'hourlyPayRate' && field.altName !== 'hourlyMargin' && field.altName !== 'endDate');
    }
    let fieldValues = {};
    let disableStatus = false;

    if (eventStatusFromEdit) {
        if (Array.isArray(eventStatusFromEdit.activityLogs)) {
            fieldValues = eventStatusFromEdit.activityLogs[0] || {};
        } else {
            fieldValues = eventStatusFromEdit.activityLogs || {};
        }
    } else if (currentSubmitData?.isStageChanged) {
        fieldValues = currentSubmitData?.newActivityStatus?.activityLogs || {};
    } else {
        fieldValues = currentSubmitData?.currentActivityStatus?.activityLogs || {};
        disableStatus = currentSubmitData?.candidateReqExist ? true : false;
    }

    
    if (onMandatoryFieldsValidation && currentSubmitData?.email && currentSubmitData?.isStageChanged) {
        const mandatoryFields = requiredFields.filter(f => f.isMandatory === true);
        const allMandatoryFieldsFilled = mandatoryFields.every(f => {
            const fieldValue = fieldValues[f.altName];
            return fieldValue !== null && fieldValue !== undefined && fieldValue !== '';
        });
        
        
        requestAnimationFrame(() => {
            onMandatoryFieldsValidation(currentSubmitData.email, allMandatoryFieldsFilled);
        });
    }

    // Enhanced updateSubmitDataState that also triggers validation
    const handleFieldChange = (field, value) => {
        updateSubmitDataState(field, value);
        setTimeout(() => {
            if (!onMandatoryFieldsValidation || !currentSubmitData?.email) return;
            
            const mandatoryFields = requiredFields.filter(f => f.isMandatory === true);
            const allMandatoryFieldsFilled = mandatoryFields.every(f => {
                
                const fieldValue = f.altName === field ? value : fieldValues[f.altName];
                return fieldValue !== null && fieldValue !== undefined && fieldValue !== '';
            });
            
            
            onMandatoryFieldsValidation(currentSubmitData.email, allMandatoryFieldsFilled);
        }, 100);
    };

    const statusForDateDisabled = [
        configJSON.candidateRequisitionStatusCode.SELECTED,
        configJSON.candidateRequisitionStatusCode.STARTED,
        configJSON.candidateRequisitionStatusCode.Offer_Accepted,
        configJSON.candidateRequisitionStatusCode.Offer_Extended,
        configJSON.candidateRequisitionStatusCode.L1_Select,
        configJSON.candidateRequisitionStatusCode.L2_Select,
        configJSON.candidateRequisitionStatusCode.L1_Reject,
        configJSON.candidateRequisitionStatusCode.L2_Reject,
        configJSON.candidateRequisitionStatusCode.L3_Reject
    ]

    


    const renderField = (field, index) => {
        switch (field.dataType) {
            case 'Text':
                return (
                    <Grid size={{ xs: 12, sm: 6, lg: 4 }} key={field.name + "" + index}>
                        <div className="fieldContainer_bulkSubmit">
                            <label className="fieldLabel_requiredFields" data-required="false">
                                {field?.name}{field?.isMandatory ? '*' : ''}
                            </label>
                            <textarea
                                type="text"
                                rows="5"
                                placeholder='Add notes here'
                                className='textArea_bulkSubmit'
                                value={fieldValues[field.altName] || ""}
                                disabled={disableStatus}
                                onChange={(e) => handleFieldChange(field.altName, e.target.value)}
                            />
                        </div>
                    </Grid>
                );

            case 'Date':
                return (
                    <Grid size={{ xs: 12, sm: 6, lg: 4 }} key={field.name + "" + index}>
                        <div className="fieldContainer_bulkSubmit datePickerContainer_bulkSubmit">
                            <label className="fieldLabel_requiredFields" data-required="false">{field?.name}{field?.isMandatory ? '*' : ''}</label>
                            <DatePicker
                                dateFormat="MM/dd/yyyy"
                                placeholderText="Select date"
                                className="datePicker_bulkSubmit"
                                disabled={field.altName === "displayDate" || disableStatus}
                                maxDate={(statusForDateDisabled.includes(currentStatus?.candidateStatusCode) && field.altName === "eventDate") ? new Date() : null}
                                showIcon={true}
                                selected={fieldValues[field.altName] ? DateTime.fromISO(fieldValues[field.altName]).toJSDate() : null}
                                onChange={(date) => handleFieldChange(field.altName, date ? DateTime.fromJSDate(date).toISO() : null)}
                            />
                        </div>
                    </Grid>
                );

            case 'Number':
                return (
                    <Grid size={{ xs: 12, sm: 6, lg: 4 }} key={field.name + "" + index}>
                        <div className="fieldContainer_bulkSubmit">
                            <label className="fieldLabel_requiredFields">{field?.name}{field?.isMandatory ? '*' : ''}</label>
                            <TextField
                                className="textField_bulkSubmit"
                                type="number"
                                placeholder="Enter salary offered"
                                variant="outlined"
                                size="small"
                                fullWidth
                                value={fieldValues[field.altName] || ""}
                                disabled={disableStatus}
                                onChange={(e) => handleFieldChange(field.altName, e.target.value)}
                                inputProps={{ min: 0 }}
                            />
                        </div>
                    </Grid>

                );

            default:
                return null
        }
    };

    return (
        <>
            {currentStatus?.candidateStatusCode === configJSON.candidateRequisitionStatusCode.SUBMITTED && currentStatus?.submissionType.length > 0 && (
                <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
                    <div className="fieldContainer_bulkSubmit">
                        <label className="fieldLabel_requiredFields">Submission Type*</label>
                        <Autocomplete
                            className="autocomplete_bulkSubmit"
                            options={currentStatus?.submissionType || []}
                            getOptionLabel={(option) => option.type || ""}
                            value={{ type: fieldValues.submissionStatus || "" }}
                            disabled={eventStatusFromEdit ? fieldValues.submissionStatus === "External" ? true : false : disableStatus}
                            onChange={(event, newValue) => {
                                handleFieldChange("submissionStatus", newValue?.type || "");
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    placeholder="Select submission type"
                                    variant="outlined"
                                    size="small"
                                />
                            )}
                        />
                    </div>
                </Grid>
            )}
            {requiredFields.map((field, index) => renderField(field, index))}
        </>

    );
}

export { renderStageRequiredField };